export const amex = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/amex.svg';

export const applePay = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/applepay.svg';

export const bancontact = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/bancontact.svg';

export const discover = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/discover.svg';

export const googlePay = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/googlepay.svg';

export const jcb = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/jcb.svg';

export const klarna = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/klarna.svg';

export const maestro = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/maestro.svg';

export const mastercard = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/mastercard.svg';

export const paypal = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/paypal_border.svg';

export const sofort = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/sofort.svg';

export const visa = 'https://cdn.getyourguide.com/tf/assets/static/payment-methods/visa.svg';
